/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
export const StateNameTypeFormatter = (cellContent, row, rowIndex) => {
  const { state_name = "-" } = row;
  return (
    <>
      <div className="d-flex align-items-center">
        <div>
          <span className="text-dark-75 d-block text-capitalize">{`${state_name} `}</span>
        </div>
      </div>
      <> </>
    </>
  );
};
